import React from 'react';
import { LegalDocumentLayout } from './common/LegalDocumentLayout';
import { LegalSection, LegalList, LegalListItem, LegalSubsection } from './common/LegalSection';

export const TermsUser: React.FC = () => {
  return (
    <LegalDocumentLayout
      title={'Regulamin Użytkownika\nPlatformy Spotto.pl'}
    >
      <LegalSection number={1} title="Postanowienia ogólne">
        <LegalSubsection number="1.1.">
          Niniejszy Regulamin określa zasady korzystania przez Użytkowników z Platformy
          rezerwacyjnej SPOTTO.pl („Platforma", „Platforma Spotto"), prowadzonej przez
          SOLID LABS PSA, z siedzibą przy ul. Mogilskiej 43, 31-545 Kraków, NIP: 6751768986
          („Administrator").
        </LegalSubsection>
        <LegalSubsection number="1.2.">
          Regulamin stanowi integralną część Regulaminu korzystania z Serwisu SPOTTO.pl.
        </LegalSubsection>
        <LegalSubsection number="1.3.">
          Użytkownikiem Platformy jest każda osoba fizyczna lub prawna, która założyła konto
          i dokonuje rezerwacji lub zakupu usług sportowych, rekreacyjnych lub trenerskich.
        </LegalSubsection>
        <LegalSubsection number="1.4.">
          Obiekt lub Biznes to partner biznesowy Spotto, posiadający działalność gospodarczą
          związaną z wynajmem obiektu i lub usług sportowych, który jest obecny na platformie
          Spotto.
        </LegalSubsection>
        <LegalSubsection number="1.5.">
          Trener to osoba posiadająca działalność gospodarczą oraz odpowiednie uprawnienia
          i wymagane doświadczenie w danej dziedzinie sportu, które umożliwiają jej sprzedaż
          usług za pośrednictwem platformy Spotto.
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={2} title="Rejestracja i konto Użytkownika">
        <LegalSubsection number="2.1.">
          Warunkiem korzystania z funkcjonalności rezerwacyjnych Platformy jest posiadanie
          aktywnego konta Użytkownika.
        </LegalSubsection>
        <LegalSubsection number="2.2.">
          Podczas rejestracji Użytkownik zobowiązany jest do podania prawdziwych, aktualnych
          i kompletnych danych osobowych.
        </LegalSubsection>
        <LegalSubsection number="2.3.">
          Administrator nie ponosi odpowiedzialności za skutki podania danych nieprawdziwych,
          nieaktualnych lub błędnych, w szczególności za brak możliwości realizacji rezerwacji.
        </LegalSubsection>
        <LegalSubsection number="2.4.">
          Użytkownik ponosi pełną odpowiedzialność za bezpieczeństwo swojego konta, w tym
          loginu i hasła.
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={3} title="Zasady rezerwacji i płatności">
        <LegalSubsection number="3.1.">
          Rezerwacje dokonywane za pośrednictwem Platformy są wiążące i skutkują zawarciem
          umowy pomiędzy Użytkownikiem a danym Obiektem lub Trenerem.
        </LegalSubsection>
        <LegalSubsection number="3.2.">
          Rezerwacje są płatne i realizowane za pośrednictwem systemu transakcyjnego
          obsługiwanego przez zewnętrznego operatora płatności, w związku z czym Użytkownik
          powinien dokonywać rezerwacji w sposób rozważny i odpowiedzialny.
        </LegalSubsection>
        <LegalSubsection number="3.3.">
          Po skutecznym dokonaniu płatności Użytkownik otrzymuje potwierdzenie rezerwacji
          drogą elektroniczną.
        </LegalSubsection>
        <LegalSubsection number="3.4.">
          Administrator nie jest stroną umowy zawartej pomiędzy Użytkownikiem a Obiektem
          lub Trenerem.
        </LegalSubsection>
        <LegalSubsection number="3.5.">
          Zaleca się, aby przed dokonaniem rezerwacji Użytkownik zapoznał się z regulaminem
          danego obiektu, a w przypadku jakichkolwiek wątpliwości skontaktował się bezpośrednio
          z danym Biznesem. Dane kontaktowe do Biznesu dostępne są w profilu Obiektu lub
          Trenera na platformie Spotto, a także po przejściu z profilu Biznesu w aplikacji
          Spotto na stronę internetową za pośrednictwem linku „Regulamin Obiektu".
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={4} title="Anulowanie rezerwacji i zwroty">
        <LegalSubsection number="4.1.">
          Możliwe jest dokonanie bezkosztowej modyfikacji zaplanowanej rezerwacji w terminie
          nie krótszym niż 48 godzin przed wydarzeniem poprzez kontakt telefoniczny z Obiektem.
          Numer kontaktowy można znaleźć w zakładce „Rezerwacje" w szczegółach danej rezerwacji
          lub w e-mailu potwierdzającym rezerwację.
        </LegalSubsection>
        <LegalSubsection number="4.2.">
          Platforma umożliwia anulowanie rezerwacji dotyczącej Obiektu sportowego najpóźniej
          na 48 godzin przed planowanym rozpoczęciem wydarzenia.
        </LegalSubsection>
        <LegalSubsection number="4.3.">
          W przypadku skutecznego anulowania rezerwacji Obiektu, zwrot środków następuje
          z potrąceniem min. 10% wartości rezerwacji, stanowiących koszty operacyjne
          i przetwarzania transakcji (zależne od polityki obiektu).
        </LegalSubsection>
        <LegalSubsection number="4.4.">
          Poprawnie zgłoszona anulacja rezerwacji jest każdorazowo potwierdzona wiadomością
          e-mail wysłaną na adres przypisany do konta Użytkownika.
        </LegalSubsection>
        <LegalSubsection number="4.5.">
          Forma oraz termin zwrotu pozostałej kwoty podlegają indywidualnym ustaleniom
          pomiędzy Użytkownikiem a danym Obiektem. Administrator Platformy nie pośredniczy
          w tym procesie.
        </LegalSubsection>
        <LegalSubsection number="4.6.">
          Anulowanie rezerwacji usług trenerskich (treningów) nie jest obsługiwane w obecnej
          wersji aplikacji mobilnej Spotto.
        </LegalSubsection>
        <LegalSubsection number="4.7.">
          W przypadku niestawienia się Użytkownika w terminie rezerwacji lub anulowania
          po upływie wskazanego terminu, Użytkownikowi nie przysługuje zwrot środków.
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={5} title="Wymagane dokumenty i uprawnienia">
        <LegalSubsection number="5.1.">
          Użytkownik zobowiązany jest do posiadania oraz okazania wszystkich dokumentów
          i uprawnień wymaganych do skorzystania z danej usługi w Obiekcie.
        </LegalSubsection>
        <LegalSubsection number="5.2.">
          W szczególności dotyczy to obiektów o podwyższonych wymaganiach formalnych, takich
          jak strzelnice, gdzie mogą być wymagane m.in.:
        </LegalSubsection>
        <LegalList>
          <LegalListItem>ważna licencja strzelecka,</LegalListItem>
          <LegalListItem>tzw. „czerwona książeczka" posiadacza broni,</LegalListItem>
          <LegalListItem>inne dokumenty wymagane przepisami prawa lub regulaminem Obiektu.</LegalListItem>
        </LegalList>
        <LegalSubsection number="5.3.">
          Brak wymaganych dokumentów lub uprawnień w dniu realizacji usługi nie stanowi
          podstawy do zwrotu kosztów rezerwacji.
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={6} title="Odpowiedzialność i bezpieczeństwo">
        <LegalSubsection number="6.1.">
          Użytkownik korzysta z usług oferowanych przez Obiekty i Trenerów na własną
          odpowiedzialność.
        </LegalSubsection>
        <LegalSubsection number="6.2.">
          Administrator nie ponosi odpowiedzialności za wypadki, urazy, szkody osobowe lub
          majątkowe powstałe w trakcie korzystania z usług.
        </LegalSubsection>
        <LegalSubsection number="6.3.">
          Użytkownik zobowiązany jest do przestrzegania regulaminów Obiektów, poleceń personelu
          oraz zasad bezpieczeństwa.
        </LegalSubsection>
        <LegalSubsection number="6.4.">
          Administrator dostarcza system transakcyjny i ponosi odpowiedzialność za
          funkcjonowanie systemu.
        </LegalSubsection>
        <LegalSubsection number="6.5.">
          Administrator nie jest stroną umowy ani stosunków prawnych pomiędzy Użytkownikiem
          a Obiektem lub Trenerem, w szczególności zawartej umowy sprzedaży, dlatego nie ponosi
          odpowiedzialności z nimi związanej.
        </LegalSubsection>
        <LegalSubsection number="6.6.">
          Administrator nie ponosi żadnej odpowiedzialności wobec Użytkownika za niewykonanie
          lub nienależyte wykonanie zobowiązania przez Obiekt czy Trenera (np. brak usługi,
          jakość usługi etc.).
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={7} title="Reklamacje">
        <LegalSubsection number="7.1.">
          Reklamacje dotyczące jakości, przebiegu lub realizacji usług należy kierować
          w pierwszej kolejności bezpośrednio do Obiektu lub Trenera, który świadczył usługę.
        </LegalSubsection>
        <LegalSubsection number="7.2.">
          Dane kontaktowe, na które należy zgłaszać reklamacje (nr telefonu i adres e-mail),
          są dostępne na platformie Spotto w profilu danego Obiektu lub Trenera oraz
          w szczegółach danej rezerwacji.
        </LegalSubsection>
        <LegalSubsection number="7.3.">
          Administrator (SOLID LABS PSA) nie jest stroną umowy rezerwacyjnej zawartej pomiędzy
          Użytkownikiem a Obiektem lub Trenerem i nie ponosi odpowiedzialności za ich działania
          lub zaniechania.
        </LegalSubsection>
        <LegalSubsection number="7.4.">
          Reklamacje dotyczące funkcjonowania Platformy należy zgłaszać na adres:{' '}
          <a
            href="mailto:reklamacje@spotto.pl"
            className="text-brand-primary hover:text-brand-primary-hover transition-colors"
          >
            reklamacje@spotto.pl
          </a>
          .
        </LegalSubsection>
        <LegalSubsection number="7.5.">
          Reklamacje zgłoszone do Platformy będą obsługiwane na bieżąco. Administrator
          zobowiązuje się do podjęcia działań w sprawie pojedynczego zgłoszenia nie później
          niż w terminie 14 dni od dnia jego otrzymania. Rozwiązanie sprawy nastąpi
          niezwłocznie, w czasie niezbędnym do prawidłowej obsługi danego zdarzenia,
          z uwzględnieniem jego charakteru, stopnia skomplikowania oraz konieczności
          współpracy z Obiektem lub Trenerem.
        </LegalSubsection>
        <LegalSubsection number="7.6.">
          W przypadku podejrzenia nieuczciwych, nieprofesjonalnych lub niezgodnych
          z Regulaminem działań Trenera lub Obiektu, Użytkownik ma prawo zgłosić takie
          zdarzenie do Administratora Platformy za pośrednictwem adresu e-mail:{' '}
          <a
            href="mailto:reklamacje@spotto.pl"
            className="text-brand-primary hover:text-brand-primary-hover transition-colors"
          >
            reklamacje@spotto.pl
          </a>
          .
        </LegalSubsection>
        <LegalSubsection number="7.7.">
          W przypadkach rażących naruszeń Regulaminu, prawa lub zasad współpracy, Administrator
          zastrzega sobie prawo do podjęcia działań administracyjnych, w tym czasowego
          zawieszenia konta, usunięcia oferty lub rozwiązania umowy z Użytkownikiem, Obiektem
          lub Trenerem będącym stroną sporu.
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={8} title="Dane osobowe">
        <LegalSubsection number="8.1.">
          Administratorem danych osobowych Użytkowników jest SOLID LABS PSA o numerze NIP:
          6751768986, z siedzibą w Krakowie przy ul. Mogilskiej 43, kod pocztowy 31-545.
        </LegalSubsection>
        <LegalSubsection number="8.2.">
          Dane osobowe przetwarzane są zgodnie z przepisami RODO oraz Polityką Prywatności
          Platformy. Kontakt w sprawach ochrony danych:{' '}
          <a
            href="mailto:rodo@spotto.pl"
            className="text-brand-primary hover:text-brand-primary-hover transition-colors"
          >
            rodo@spotto.pl
          </a>
          .
        </LegalSubsection>
        <LegalSubsection number="8.3.">
          Użytkownik ma prawo dostępu do danych, ich poprawiania, usunięcia oraz ograniczenia
          przetwarzania.
        </LegalSubsection>
      </LegalSection>

      <LegalSection number={9} title="Postanowienia końcowe">
        <LegalSubsection number="9.1.">
          Administrator zastrzega sobie prawo do zmiany Regulaminu.
        </LegalSubsection>
        <LegalSubsection number="9.2.">
          Zmiany Regulaminu wchodzą w życie z dniem ich opublikowania na Platformie.
        </LegalSubsection>
        <LegalSubsection number="9.3.">
          W sprawach nieuregulowanych niniejszym Regulaminem zastosowanie mają przepisy prawa
          polskiego.
        </LegalSubsection>
      </LegalSection>
    </LegalDocumentLayout>
  );
};
